import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, OnInit } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from '../../app-shared.module';
import { EmbeddingOptions } from '../../providers/storage-api/interactive-smart-summary.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from '../../services/otel.service';

export interface EmbeddingOptionsComponentOptions {
  embeddingOptions: EmbeddingOptions;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-embedding-options',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './embedding-options.component.html',
  styleUrls: ['./embedding-options.component.scss'],
})
export class EmbeddingOptionsComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public isLoading = false;
  strategyDropDownData: DropdownObject[] = [];
  modelDropDownData: DropdownObject[] = [];
  selectedModel: string;
  selectedStrategy: string;

  constructor(
    private dialogRef: MatDialogRef<EmbeddingOptionsComponent>,
    @Inject(MAT_DIALOG_DATA) private options: EmbeddingOptionsComponentOptions
  ) {}

  ngOnInit() {
    this.isLoading = true;
    for (const model of this.options.embeddingOptions.models) {
      this.modelDropDownData.push({ title: model, id: model });
    }

    for (const strategy of this.options.embeddingOptions.strategies) {
      this.strategyDropDownData.push({ title: strategy, id: strategy });
    }
    this.selectedModel = this.modelDropDownData.at(0).id;
    this.selectedStrategy = this.strategyDropDownData.at(0).id;
    this.isLoading = false;
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public async confirm(): Promise<void> {
    const result = {
      model: this.selectedModel,
      strategy: this.selectedStrategy,
    };

    // FIXME: SNACKBAR
    this.dialogRef.close(result);
  }
}
